// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sHJ-","name":"styles_name__1IMkD","phone":"styles_phone__3B41Y"};